import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    hideRadio: {
        visibility: 'hidden',
        width: 0,
        height: 0,
        padding: 0
    },
    invitesContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '17px'
    },
    invites: {
        display: 'flex',
        justifyContent: 'space-around',
        marginTop: theme.spacing(2),
        marginBottom: '32px',
        gap: '10px',
        flexDirection: 'row',
        flexWrap: 'wrap',
        [theme.breakpoints.down('758')]: {
            marginBottom: 0
        },
        // [theme.breakpoints.down('sm')]: {
        //     flexDirection: 'column'
        // },
        // [theme.breakpoints.up('sm')]: {
        //     flexDirection: 'row',
        //     flexWrap: 'wrap'
        // }
    },
    inviteContainer: {
        display: 'block',
        width: '156px',
        height: '156px',
        margin: "0 0 25px 0",
        '&:last-child': { marginRight: 0 },
        '& .MuiFormControlLabel-label': {
            display: 'inline-block',
            height: '100%',
            position: 'relative'
        },
        [theme.breakpoints.down('430')]: {
            width: '120px',
            height: '120px'
        }
    },
    inviteImg: {
        borderRadius: '10px',
        width: "100%",
        height: "100%",
        '&:hover': {
            opacity: 0.7
        }
    },
    overlayContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        borderRadius: '10px',
        backgroundColor: 'rgba(18,42,255, 0.71)',
    },
    continueBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        borderRadius: '20px',
        height: '40px',
        paddingLeft: '24px',
        paddingRight: '16px',
        color: '#000',
        backgroundColor: '#fff',
        boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important',
        '& svg': {
            position: 'relative',
            left: '8px',
            [theme.breakpoints.down('430')]: {
                left: '2px'
            },
        },
        '&:hover': {
            backgroundColor: '#fff'
        },
        [theme.breakpoints.down('430')]: {
            height: '34px',
            fontSize: '12px',
            paddingLeft: '14px',
            paddingRight: '8px',
        }
    },
    overlayIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '40px',
        height: '40px',
        marginTop: '22px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        [theme.breakpoints.down('430')]: {
            width: '34px',
            height: '34px',
            '& svg': {
                width: '0.8em'
            }
        },
    }
}));

export { useStyles };